import { api } from "../../api/client";

export function getSessionLogs() {
  return api.get("/admin/session-logs");
}
